/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentials
 */
export interface FxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentials {
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentials
     */
    Email: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentials
     */
    EmailCode?: string | null;
}

/**
 * Check if a given object implements the FxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentials interface.
 */
export function instanceOfFxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentials(value: object): value is FxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentials {
    if (!('Email' in value) || value['Email'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentialsFromJSON(json: any): FxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentials {
    return FxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentialsFromJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentialsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentials {
    if (json == null) {
        return json;
    }
    return {
        
        'Email': json['Email'],
        'EmailCode': json['EmailCode'] == null ? undefined : json['EmailCode'],
    };
}

export function FxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentialsToJSON(json: any): FxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentials {
    return FxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentialsToJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentialsToJSONTyped(value?: FxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentials | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Email': value['Email'],
        'EmailCode': value['EmailCode'],
    };
}

